<div id="<%= dom_id user %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Userid:</strong>
    <%= user.userid %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Email:</strong>
    <%= user.email %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Name1:</strong>
    <%= user.name1 %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Name2:</strong>
    <%= user.name2 %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Password:</strong>
    <%= user.password %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Token:</strong>
    <%= user.token %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Link:</strong>
    <%= user.link %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Sites:</strong>
    <%= user.sites %>
  </div>
</div>
